import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function downloadFile(path, fallbackName) {
  let res;
  for (let i = 0; i < 40; i++) {
    res = await http.get(path, { responseType: "blob", timeout: 55000 });
    if (res.status !== 202) break;
    if (i === 0) toast.info("Preparing your PDF — large kits take about a minute. The download will start automatically.");
    await sleep(6000);
  }
  if (res.status === 202) throw new Error("The PDF is still being prepared — please try again in a minute.");
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="([^"]+)"/) || [])[1] || fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const EDITION_COLORS = {
  wine: { primary: "#8B4050", border: "#A45064", dark: "#261820" },
  luxury: { primary: "#C9A847", border: "#B08E3A", dark: "#2C2B26" },
  solo: { primary: "#2A6041", border: "#40916C", dark: "#1C2B22" },
  escape: { primary: "#4A7A9B", border: "#457B9D", dark: "#1A3347" },
  adventure: { primary: "#B5562B", border: "#D0743F", dark: "#2A1D15" },
};

const PDF_PALETTES = {
  wine: { primary: "#8B4050", border: "#C4A0AC", dark: "#261820", tint: "#FAF4F0", band: "#EBDDE1" },
  solo: { primary: "#2A6041", border: "#A8C9B5", dark: "#1C2B22", tint: "#F0F5F2", band: "#DCE9E1" },
  escape: { primary: "#4A7A9B", border: "#A8C4D4", dark: "#1A3347", tint: "#EDF4F7", band: "#DCE8EF" },
  adventure: { primary: "#B5562B", border: "#D9B49C", dark: "#2A1D15", tint: "#F8F1EC", band: "#F1E1D6" },
  luxury: { primary: "#C9A847", border: "#D4B86A", dark: "#2C2B26", tint: "#FAF7ED", band: "#F1E8CF" },
};
const FOUNDER_PALETTES = {
  wine: { primary: "#7B2D3B", border: "#B89653", dark: "#3E1620", tint: "#F8F0F2", band: "#EBDDE1" },
  luxury: { primary: "#8B6A2B", border: "#B89653", dark: "#2C2B26", tint: "#FAF6EC", band: "#F1E8CF" },
  solo: { primary: "#2A6041", border: "#B89653", dark: "#14281C", tint: "#EFF5F1", band: "#DCE9E1" },
  escape: { primary: "#2A5F80", border: "#C4A882", dark: "#13293A", tint: "#EDF4F7", band: "#DCE8EF" },
  adventure: { primary: "#8A3F1D", border: "#B89653", dark: "#2A1D15", tint: "#F8F1EC", band: "#F1E1D6" },
};
export const kitPalette = (kit) => (kit.collection === "founders" ? FOUNDER_PALETTES : PDF_PALETTES)[kit.edition] || PDF_PALETTES.escape;

export const EDITION_IMAGES = {
  wine: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  luxury: "https://images.unsplash.com/photo-1549294413-26f195200c16?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  solo: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  escape: "https://images.unsplash.com/photo-1596142332133-327e2a0ff006?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  adventure: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};
